import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { InputSwitch } from 'primereact/inputswitch';

/**
 * Bloco "Sociodemografia" da aba Ferramentas (dados censitários / camadas Linkages),
 * compartilhado entre os mapas Mapbox. É só apresentação: toda a lógica vive em
 * `datalayerFeature.js` e chega por props.
 *
 * Não renderiza nada quando o usuário não tem nenhuma permissão de camada.
 */
const SociodemografiaTools = ({
    permissoes,
    datalayers,
    datalayerName,
    datalayerColorProperty,
    datalayerColorPropertyOptions,
    datalayerYear,
    datalayerYears,
    datalayerYearOptions,
    showDemarcacaoAreas,
    loading,
    requerPropriedade,
    requerAno,
    requerMultiplosAnos,
    onChangeName,
    onChangeColorProperty,
    onChangeYear,
    onChangeYears,
    onLoadDataLayer,
    onChangeDemarcacaoAreas,
    onOpenDataDictionary,
    onOpenDataTable,
}) => {
    if (!permissoes || permissoes.length === 0) return null;

    return (
        <>
            <hr />
            <div className="form-group">
                <label className="mb-4 d-block">Sociodemografia</label>

                <label className="mb-2 d-block">Categoria</label>
                <div className="d-flex align-items-center justify-content-between">
                    <select
                        style={{ height: '43px' }}
                        className="form-control"
                        value={datalayerName}
                        onChange={onChangeName}
                    >
                        <option value="">Selecione</option>
                        {datalayers.map((layerGroupAndOptions) => (
                            <optgroup label={layerGroupAndOptions.group} key={layerGroupAndOptions.group}>
                                {layerGroupAndOptions.options.map((option) => (
                                    <option value={option.value} key={option.value}>{option.label}</option>
                                ))}
                            </optgroup>
                        ))}
                    </select>
                    <button
                        type="button"
                        className="btn btn-primary btn-link ms-2"
                        title="Dicionário de Dados"
                        onClick={onOpenDataDictionary}
                    >
                        <i className="fa-solid fa-circle-info"></i>
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-link"
                        title="Tabela de Dados"
                        disabled={!datalayerName}
                        onClick={onOpenDataTable}
                    >
                        <i className="fas fa-table"></i>
                    </button>
                </div>

                {requerPropriedade && (
                    <div className="mt-2">
                        <label className="mb-1 d-block">Variável:</label>
                        <Dropdown
                            options={datalayerColorPropertyOptions}
                            onChange={onChangeColorProperty}
                            style={{ width: '100%' }}
                            value={datalayerColorProperty}
                            showClear
                            placeholder="Selecione"
                            disabled={!datalayerName}
                        />
                    </div>
                )}

                {requerAno && (
                    <div className="mt-2">
                        <label className="mb-1 d-block">Ano:</label>
                        <Dropdown
                            options={datalayerYearOptions?.[datalayerName] || []}
                            onChange={onChangeYear}
                            style={{ width: '100%' }}
                            value={datalayerYear}
                            showClear
                            placeholder="Selecione"
                            disabled={!datalayerName}
                        />
                    </div>
                )}

                {requerMultiplosAnos && (
                    <div className="mt-2">
                        <label className="mb-1 d-block">Ano:</label>
                        <MultiSelect
                            options={datalayerYearOptions?.[datalayerName] || []}
                            onChange={onChangeYears}
                            display="chip"
                            style={{ width: '100%' }}
                            value={datalayerYears}
                            placeholder="Selecione"
                            disabled={!datalayerName}
                        />
                        <button
                            type="button"
                            className="btn btn-sm btn-primary btn-block mt-2"
                            onClick={onLoadDataLayer}
                            disabled={!datalayerName || datalayerYears?.length === 0}
                        >
                            Carregar Dados
                        </button>
                    </div>
                )}

                {datalayerName && (
                    <div className="d-flex align-items-center mt-3">
                        <InputSwitch
                            inputId="check_demarcacao_areas"
                            checked={showDemarcacaoAreas}
                            onChange={(e) => onChangeDemarcacaoAreas(e.value)}
                        />
                        <label htmlFor="check_demarcacao_areas" className="pl-1 mb-0 ms-2">
                            Exibir demarcação de áreas
                        </label>
                    </div>
                )}

                {loading && (
                    <small className="text-muted d-block mt-2">Carregando dados…</small>
                )}
            </div>
        </>
    );
};

export default SociodemografiaTools;
